module.exports = __webpack_public_path__ + "static/img/97025C_2_3_R_20190903_LC.468f82f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/97025C_2_3_R_20190903_LC.png
// module id = +16y
// module chunks = 0